export const MARKETPLACE_DEVELOPER_STUDIO_ROUTES = {
  ROOT: '/app-studio',
  CUSTOM_APP: '/app-studio/custom-app',
  PUBLIC_APP: '/app-studio/public-app',
  PROFILE_PAGE: '/app-studio/profile',
  INSIGHTS: '/app-studio/insights',
  BROWSE: '/app-studio',
} as const;
